module.exports = __webpack_public_path__ + "media/bootstrap-icons/pie-chart-fill-5bce15dd.svg";